import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createEmployeeEntry = createAsyncThunk('createEmployeeEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertEmployee`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateEmployeeEntry = createAsyncThunk('updateEmployeeEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateEmployee`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchEmployeeData = createAsyncThunk('fetchEmployeeData', async (id) => {
    try {
        const endpoint = id ? `getEmplist&empId=${id}` : 'getEmplist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchEmpAttendanceReg = createAsyncThunk('fetchEmpAttendanceReg', async (id) => {
    try {
        const endpoint = id ? `getEmpAttendanceReg&atId=${id}` : 'getEmpAttendanceReg';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleEmployee = createAsyncThunk('fetchSingleEmployee', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getEmplist&empId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleEmployee = createAsyncThunk('deleteSingleEmployee', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteEmployee&empId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const employeeSlice = createSlice({
    name: 'EmployeeData',
    initialState: {
        isLoading: false,
        employee: null,
        deleteEmployee: null,
        singleEmployee: null,
        atnd: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchEmployeeData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchEmployeeData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.employee = action.payload;
        });
        builder.addCase(fetchEmployeeData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleEmployee.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleEmployee.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteEmployee = action.payload;
        });
        builder.addCase(deleteSingleEmployee.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleEmployee.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleEmployee.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleEmployee = action.payload;
        });
        builder.addCase(fetchSingleEmployee.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchEmpAttendanceReg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchEmpAttendanceReg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.atnd = action.payload;
        });
        builder.addCase(fetchEmpAttendanceReg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


    }
});

export default employeeSlice.reducer;
